import React from 'react';

import {IconCalendarRecurring, IconCalendarTodaySmallOutline, IconPoll} from '@zoom/sun-ui-icon';
import {useTranslation} from 'react-i18next';
// import {useSelector} from 'react-redux';

import {IconContainer} from './Style';

import {getApptType} from 'Utils';
import {getCapacityTypeText} from 'Utils/CardDisplay';
import {APPT_TYPE} from 'Utils/consts';

const APPT_TYPE_ICON_MAP = {
  [APPT_TYPE.ONE_OFF]: <IconCalendarTodaySmallOutline />,
  [APPT_TYPE.POLL]: <IconPoll />,
};

/**
 * Appointment Capacity Type Component
 * @param {{appointment: Appt, showIcon: boolean}} props
 * @return {ReactElement}
 */
export default function CapacityType(props) {
  const {
    appointment,
    showIcon = true,
  } = props;
  const {t} = useTranslation();
  const apptType = getApptType(appointment);

  const type = t(getCapacityTypeText(appointment, apptType));

  return (
    <IconContainer>
      {showIcon && <>{APPT_TYPE_ICON_MAP[apptType] || <IconCalendarRecurring />}</>}
      <span>{type}</span>
    </IconContainer>
  );
}
